import { component } from 'picoapp';

export default component((node) => {
  const videoElement = node.querySelector<HTMLVideoElement>('[data-video]');
  const videoPlayButton = node.querySelector<HTMLElement>('[data-play-video]');

  if (videoElement) {
    videoPlayButton.addEventListener('click', () => {
      videoElement.play();
      videoPlayButton.hidden = true;
    });

    videoElement.addEventListener('pause', () => {
      videoElement.pause();
      videoPlayButton.hidden = false;
    });

    if (videoElement.paused) {
      videoElement.addEventListener('play', () => {
        videoPlayButton.hidden = true;
      });
    }

    if (videoElement.played) {
      videoElement.addEventListener('click', () => {
        videoElement.pause();
        videoPlayButton.hidden = false;
      });
    }
  }
});
